import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 10,
    },
    button: {
      background: 'linear-gradient(45deg, #3D3B8E 30%, #006494 90%)',
      margin: 10,
      color: 'white',
    },
  })
);
